export function contactForm() {
    const _categories = [
        'Demo',
        'Custom Creation',
        'Custom Development',
        'Design',
        'Integrations',
        'Shopify',
        'WooCommerce',
        'Magento 2',
        'Custom Integration',
        'Other Integration',
        'Become a Partner',
        'Enterprise',
    ];
    const formEl = document.querySelector('.contact-form--js');
    if (!!formEl === false) return;
    const ariaLabels = {
        select: 'Select category',
        selected: 'Deselect category',
    };
    const categoriesListEl = formEl.querySelector('.categories-list--js');
    const categoriesInputEl = formEl.querySelector('.categories-input--js');
    const selectedCategoriesEl = formEl.querySelector('.selected-categories--js');

    new ResizeObserver(() => {
        formEl.style.setProperty('--categories-height', selectedCategoriesEl.clientHeight + 'px');
    }).observe(selectedCategoriesEl);

    const categories = _categories.map((categoryName) => {
        const el = document.createElement('button');
        const category = { name: categoryName, selected: false, el };
        el.type = 'button';
        el.ariaLabel = ariaLabels.select;
        el.classList.add('category');
        el.innerHTML = `<span>${categoryName}</span>`;
        el.addEventListener('click', () => {
            category.selected ? deselectCategory(category) : selectCategory(category);
        });
        return category;
    });

    const flickingContainer = document.createElement('div');
    flickingContainer.id = 'contact-form-flicking';
    flickingContainer.classList.add('class', 'flicking-viewport');
    flickingContainer.innerHTML = '<div class="flicking-camera"></div>';
    const flickingCamera = flickingContainer.firstElementChild;
    categories.forEach((category) => {
        flickingCamera.appendChild(category.el);
    });
    categoriesListEl.appendChild(flickingContainer);

    const flicking = new Flicking(flickingContainer, {
        bound: true,
        align: 'prev',
        dragThreshold: 10,
        preventClickOnDrag: false,
        duration: 300,
        inputType: ['pointer'],
    });

    function syncSelected() {
        selectedCategoriesEl.innerHTML = '';
        const selectedCategoryNames = [];
        categories.forEach((category) => {
            if (category.selected === false) return;
            category.el.ariaLabel = ariaLabels.selected;
            selectedCategoriesEl.appendChild(category.el);
            selectedCategoryNames.push(category.name);
        });
        categoriesInputEl.value = selectedCategoryNames.join();
    }
    function selectCategory(category) {
        category.selected = true;
        let index;
        for (let i = 0; i < flicking.panels.length; i++) {
            if (flicking.panels[i]._elProvider.element === category.el) {
                index = flicking.panels[i]._index;
                break;
            }
        }
        if (typeof index === 'number') {
            flicking.remove(index, 1);
            flicking.moveTo(Math.min(index, flicking.panels.length - 1), 0);
        }
        syncSelected();
    }
    function deselectCategory(category) {
        category.selected = false;
        category.el.ariaLabel = ariaLabels.select;
        flicking.prepend(category.el);
        flicking.moveTo(0, 0);
        syncSelected();
    }

    formEl.addEventListener('reset', () => {
        categories.forEach((category) => {
            if (category.selected) deselectCategory(category);
        });
    });
}
